import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core'
import { BrowserModule } from '@angular/platform-browser'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'

import { ScrollbarModule } from 'ngx-scrollbar'
import { SharedServices } from '../../../services/shared.services'
import { A2Edatetimepicker } from 'ng2-eonasdan-datetimepicker'
import { CommunicationRoomRoutingModule } from './communication-room.routing'
import { CommunicationRoomComponent } from './communication-room.component'
import { TimelineComponent } from './timeline/timeline.component'
import { SettingRoomComponent } from './setting-room/setting-room.component'
import { NgCircleProgressModule } from 'ng-circle-progress'
import { CommonsModule } from '../../../commons/commons.module'

@NgModule({
    imports: [
        BrowserModule,
        FormsModule,
        ReactiveFormsModule,
        ScrollbarModule,
        A2Edatetimepicker,
        CommunicationRoomRoutingModule,
        // Specify ng-circle-progress as an import
        NgCircleProgressModule.forRoot({
            // set defaults here
            radius: 100,
            outerStrokeWidth: 16,
            innerStrokeWidth: 8,
            outerStrokeColor: '#0080ff',
            innerStrokeColor: '#53a9ff',
            animationDuration: 300,
        }),
        CommonsModule,
    ],
    declarations: [
        CommunicationRoomComponent,
        TimelineComponent,
        SettingRoomComponent,
    ],
    providers: [
        SharedServices,
    ],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA,
    ],
})
export class CommunicationRoomModule {
}



// WEBPACK FOOTER //
// ./src/app/app_manager/app_element/communication-room/communication-room.module.ts